export default __webpack_public_path__ + "static/media/eduplusnow.2ab8216b.jpg";